export const removeCpfMask = (value: string): string => {
  return value.replace(/\D/g, '');
};
